import { $ } from '../utils/Utils';

const accessibility = (() => {
  const config = {
    triggers: [...$('.js-accessibiltyHelper')],
  };

  const handleKeyUp = ({ e, trigger }) => {
    // simulate click event when user presses specific keys
    switch (e.key) {
      case 'Enter':
      case 'ArrowRight':
      case 'ArrowLeft':
      case ' ':
        trigger.click();
        break;
      default:
        break;
    }
  };

  const build = () => {
    config.triggers.forEach((trigger) => {
      trigger.setAttribute('tabindex', '0');

      trigger.addEventListener('keyup', e => handleKeyUp({ e, trigger }));
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default accessibility.init();
